import { render } from "./ApprovalSearch.vue?vue&type=template&id=61d9a4a2"
import script from "./ApprovalSearch.vue?vue&type=script&lang=js"
export * from "./ApprovalSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__